export default function DottedBg(props) {
  return (
    <>
      <div className="absolute top-0 left-0 -z-20 -mt-28 h-[880px] w-full bg-gray-50 bg-cover pt-28">
        <div className="relative -z-30 -mt-28 w-full">{props.children}</div>
      </div>
    </>
  );
}
